import { featureFlagClient } from '@trello/feature-flag-client';

export function canViewTeamTablePage(
  hasViewsFeature: boolean | undefined,
  isPremium: boolean | undefined,
): boolean {
  const freeTeamUpsellEnabled = featureFlagClient.get(
    'remarkable.org-table-view-free-team-upsell',
    false,
  );
  const orgTableViewEnabled = featureFlagClient.get(
    'remarkable.org-table-view-v1',
    false,
  );

  if (freeTeamUpsellEnabled && !isPremium) {
    return true;
  } else if (orgTableViewEnabled && hasViewsFeature) {
    return true;
  } else {
    return false;
  }
}
